jQuery(document).ready(function ($) {
  const menuToggle = $("#menu-toggle");
  const menuPanel = $("#mobile-menu-panel");
  const menuClose = $("#mobile-menu-close");
  const html = $("html");
  const body = $("body");
  const siteWrapper = $(".site-wrapper");
  let menuHideTimer = null;
  let lastFocusedElement = null;
  let scrollPosition = 0;

  function getFocusableElements() {
    return menuPanel
      .find('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      .filter(":visible");
  }

  function setPageInert(isInert) {
    if (!siteWrapper.length) {
      return;
    }

    siteWrapper
      .children()
      .not(".nav-header")
      .each(function () {
        if ("inert" in this) {
          this.inert = isInert;
        }
      });
  }

  function lockScroll() {
    scrollPosition = window.scrollY || window.pageYOffset || 0;
    html.addClass("menu-open");
    body.addClass("menu-open");
  }

  function unlockScroll() {
    html.removeClass("menu-open");
    body.removeClass("menu-open");
    window.scrollTo({ top: scrollPosition, behavior: "instant" });
  }

  function resetSubmenus() {
    menuPanel.find(".mobile-submenu-toggle").attr("aria-expanded", "false");
    menuPanel
      .find(".sub-menu")
      .prop("hidden", true)
      .removeClass("is-open")
      .css("height", "");
  }

  function setMenuState(isOpen) {
    clearTimeout(menuHideTimer);

    menuToggle
      .attr("aria-expanded", isOpen ? "true" : "false")
      .attr("aria-label", isOpen ? "Close menu" : "Open menu")
      .toggleClass("active", isOpen);

    menuPanel.attr("aria-hidden", isOpen ? "false" : "true");

    if (isOpen) {
      lastFocusedElement = document.activeElement;
      menuPanel.prop("hidden", false);
      requestAnimationFrame(function () {
        menuPanel.addClass("is-open");
      });
      lockScroll();
      setPageInert(true);

      requestAnimationFrame(function () {
        if (menuClose.length && menuClose.is(":visible")) {
          menuClose.trigger("focus");
          return;
        }

        const focusable = getFocusableElements();
        if (focusable.length) {
          focusable.first().trigger("focus");
        }
      });

      return;
    }

    menuPanel.removeClass("is-open");
    resetSubmenus();
    setPageInert(false);
    unlockScroll();

    menuHideTimer = window.setTimeout(function () {
      menuPanel.prop("hidden", true);
    }, 220);

    if (lastFocusedElement && typeof lastFocusedElement.focus === "function") {
      lastFocusedElement.focus();
    } else {
      menuToggle.trigger("focus");
    }
  }

  function getControlledSubmenu(toggleButton) {
    const controls = toggleButton.attr("aria-controls");
    if (controls) {
      const submenu = document.getElementById(controls);
      if (submenu) {
        return $(submenu);
      }
    }

    return toggleButton.closest("li").children(".sub-menu");
  }

  function closeSubmenu(toggleButton, instant) {
    const submenu = getControlledSubmenu(toggleButton);

    if (!submenu.length) {
      return;
    }

    toggleButton.attr("aria-expanded", "false");

    if (instant) {
      submenu.prop("hidden", true).removeClass("is-open").css("height", "");
      return;
    }

    submenu.css("height", `${submenu[0].scrollHeight}px`);

    requestAnimationFrame(function () {
      submenu.removeClass("is-open").css("height", "0px");
    });

    submenu.one("transitionend", function (event) {
      if (
        event.originalEvent &&
        event.originalEvent.propertyName !== "height"
      ) {
        return;
      }

      if (toggleButton.attr("aria-expanded") === "false") {
        submenu.prop("hidden", true).css("height", "");
      }
    });
  }

  function openSubmenu(toggleButton) {
    const submenu = getControlledSubmenu(toggleButton);

    if (!submenu.length) {
      return;
    }

    menuPanel
      .find('.mobile-submenu-toggle[aria-expanded="true"]')
      .not(toggleButton)
      .each(function () {
        closeSubmenu($(this), false);
      });

    submenu.prop("hidden", false).addClass("is-open").css("height", "0px");
    toggleButton.attr("aria-expanded", "true");

    requestAnimationFrame(function () {
      submenu.css("height", `${submenu[0].scrollHeight}px`);
    });

    submenu.one("transitionend", function (event) {
      if (
        event.originalEvent &&
        event.originalEvent.propertyName !== "height"
      ) {
        return;
      }

      if (toggleButton.attr("aria-expanded") === "true") {
        submenu.css("height", "auto");
      }
    });
  }

  function closeMenu() {
    if (!menuPanel.hasClass("is-open")) {
      return;
    }

    setMenuState(false);
  }

  function openMenu() {
    if (menuPanel.hasClass("is-open")) {
      return;
    }

    setMenuState(true);
  }

  // Toggle mobile menu
  menuToggle.on("click", function () {
    if (menuPanel.hasClass("is-open")) {
      closeMenu();
      return;
    }

    openMenu();
  });

  menuClose.on("click", function () {
    closeMenu();
  });

  // Mobile sub-menu accordion toggle
  menuPanel.on("click", ".dropdown-toggle", function (e) {
    e.preventDefault();
    const button = $(this);
    const isOpen = button.attr("aria-expanded") === "true";

    if (isOpen) {
      closeSubmenu(button, false);
      return;
    }

    openSubmenu(button);
  });

  // Close mobile menu after selecting any menu link.
  menuPanel.on("click", "a:not(.dropdown-toggle)", function () {
    closeMenu();
  });

  $(document).on("keydown", function (e) {
    if (menuPanel.hasClass("is-open")) {
      if (e.key === "Escape") {
        e.preventDefault();
        closeMenu();
        return;
      }

      if (e.key === "Tab") {
        const focusable = getFocusableElements();

        if (!focusable.length) {
          return;
        }

        const first = focusable.get(0);
        const last = focusable.get(focusable.length - 1);

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      return;
    }

    // Desktop: Escape key closes sub-menu by blurring focus
    if (e.key === "Escape") {
      const $focused = $(document.activeElement);
      if ($focused.closest(".nav-links .sub-menu").length) {
        $focused.blur();
      }
    }
  });
});

/**
 * Slick Carousel Initialization
 *
 * Auto-initializes any element with data-slick attribute.
 * Configuration is read from the data-slick JSON attribute.
 *
 * @since 1.0.0
 * @see https://accessible360.github.io/accessible-slick/
 */
jQuery(document).ready(function ($) {
  // Initialize all elements with data-slick attribute
  $("[data-slick]").each(function () {
    const $carousel = $(this);

    // Skip if already initialized
    if ($carousel.hasClass("slick-initialized")) {
      return;
    }

    // Get config from data attribute (Slick reads this automatically)
    // Just call .slick() - it will parse the data-slick JSON
    $carousel.slick();
  });

  // Testimonials Carousel - specific config with SVG arrows
  $('[data-carousel="testimonials"]').each(function () {
    const $carousel = $(this);
    const $section = $carousel.closest(".testimonials-carousel");
    const $nav = $section.find(".testimonials-nav").first();

    // Skip if already initialized
    if ($carousel.hasClass("slick-initialized") || !$nav.length) {
      return;
    }

    // SVG arrow icons (brand arrows — horizontal line + arrowhead)
    const prevArrow = [
      '<button type="button" class="slick-prev">',
      '<svg xmlns="http://www.w3.org/2000/svg" width="29" height="13" viewBox="0 0 29 13" fill="none">',
      '<path d="M28.5 6.5L0.5 6.5M0.5 6.5L6.39474 12.5M0.5 6.5L6.39474 0.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>',
      '</svg><span class="slick-sr-only">Previous</span></button>',
    ].join("");
    const nextArrow = [
      '<button type="button" class="slick-next">',
      '<svg xmlns="http://www.w3.org/2000/svg" width="29" height="13" viewBox="0 0 29 13" fill="none">',
      '<path d="M0.5 6.5L28.5 6.5M28.5 6.5L22.6053 12.5M28.5 6.5L22.6053 0.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>',
      '</svg><span class="slick-sr-only">Next</span></button>',
    ].join("");

    // Read item width directly from the rail. The current template no longer
    // emits the legacy .testimonials-carousel-wrapper helper.
    const itemWidth = parseInt($carousel.attr("data-item-width"), 10) || 448;

    // Set CSS custom property for SCSS consumption
    if ($carousel[0]) {
      $carousel[0].style.setProperty("--item-width", itemWidth + "px");
    }

    $carousel.slick({
      variableWidth: true,
      slidesToScroll: 1,
      adaptiveHeight: false,
      arrows: true,
      dots: true,
      infinite: true,
      appendArrows: $nav,
      appendDots: $nav,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            variableWidth: true,
            centerMode: true,
            centerPadding: "0px",
          },
        },
      ],
    });
  });

  // Testimonials 50/50 - specific config (single slide with arrows + dots)
  $('[data-carousel="testimonials-50-50"]').each(function () {
    const $carousel = $(this);

    // Skip if already initialized
    if ($carousel.hasClass("slick-initialized")) {
      return;
    }

    // SVG arrow icons (same as testimonials carousel)
    const prevArrow = [
      '<button type="button" class="slick-prev">',
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">',
      '<path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
      '</svg><span class="slick-sr-only">Previous</span></button>',
    ].join("");
    const nextArrow = [
      '<button type="button" class="slick-next">',
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">',
      '<path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
      '</svg><span class="slick-sr-only">Next</span></button>',
    ].join("");

    $carousel.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: true,
      appendArrows: ".testimonials-50-50__nav",
      appendDots: ".testimonials-50-50__nav",
      prevArrow: prevArrow,
      nextArrow: nextArrow,
    });
  });

  // Media Accordion Mobile Slider
  $('[data-carousel="media-accordion-mobile"]').each(function () {
    const $slider = $(this);
    const $block = $slider.closest(".media-accordion");
    const $nav = $block.find(".media-accordion__mobile-nav").first();
    const $counter = $block
      .find(".media-accordion__mobile-counter-current")
      .first();
    const stepCount = parseInt($slider.attr("data-step-count"), 10) || 0;
    const breakpoint =
      parseInt($slider.attr("data-slick-breakpoint"), 10) || 769;

    // Guard: need > 1 card and a nav container
    if (stepCount <= 1 || !$nav.length) return;

    const prevArrow = [
      '<button type="button" class="slick-prev">',
      '<svg xmlns="http://www.w3.org/2000/svg" width="29" height="13" viewBox="0 0 29 13" fill="none">',
      '<path d="M6.70672 6.50002L12.2537 12.047L11.313 12.9877L4.15918 5.83389L11.313 0.680054L12.2537 1.62074L6.70672 6.50002Z" fill="currentColor"/>',
      '<path d="M5.09961 5.8335H28.0396V7.16683H5.09961V5.8335Z" fill="currentColor"/>',
      '</svg><span class="slick-sr-only">Previous</span></button>',
    ].join("");
    const nextArrow = [
      '<button type="button" class="slick-next">',
      '<svg xmlns="http://www.w3.org/2000/svg" width="29" height="13" viewBox="0 0 29 13" fill="none">',
      '<path d="M22.2933 6.50002L16.7463 1.62074L17.687 0.680054L24.8408 5.83389L17.687 12.9877L16.7463 12.047L22.2933 6.50002Z" fill="currentColor"/>',
      '<path d="M23.9004 7.16683V5.8335H0.960449V7.16683H23.9004Z" fill="currentColor"/>',
      '</svg><span class="slick-sr-only">Next</span></button>',
    ].join("");

    const desktopMQ = window.matchMedia("(min-width: " + breakpoint + "px)");

    function updateCounter(index) {
      if ($counter.length) {
        $counter.text(String(index + 1).padStart(2, "0"));
      }
    }

    function initSlider() {
      if ($slider.hasClass("slick-initialized")) return;

      $slider.on("init.mediaAccordion", function (event, slick) {
        updateCounter(slick.currentSlide || 0);
      });

      $slider.on(
        "afterChange.mediaAccordion",
        function (event, slick, currentSlide) {
          updateCounter(currentSlide);
        },
      );

      $slider.slick({
        variableWidth: true,
        slidesToScroll: 1,
        adaptiveHeight: false,
        arrows: true,
        dots: true,
        infinite: true,
        appendArrows: $nav,
        appendDots: $nav,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        customPaging: function (slider, i) {
          return (
            '<button type="button"><span class="slick-dot-icon" aria-hidden="true"></span><span class="slick-sr-only">Go to step ' +
            (i + 1) +
            "</span></button>"
          );
        },
        responsive: [
          {
            breakpoint: 769,
            settings: {
              variableWidth: true,
              centerMode: true,
              centerPadding: "0px",
            },
          },
        ],
      });
    }

    function destroySlider() {
      if (!$slider.hasClass("slick-initialized")) return;
      $slider.off(".mediaAccordion");
      $slider.slick("unslick");
    }

    function syncSlider(e) {
      if (e.matches) {
        destroySlider();
      } else {
        initSlider();
      }
    }

    if (desktopMQ.addEventListener) {
      desktopMQ.addEventListener("change", syncSlider);
    } else if (desktopMQ.addListener) {
      desktopMQ.addListener(syncSlider);
    }

    syncSlider(desktopMQ);
  });

  // Content switcher mobile: mirror desktop index-based orb + ring switching.
  $(".content-switch__mobile").each(function () {
    const mobile = this;
    const details = mobile.querySelectorAll(
      ".content-switcher-detail[data-detail-index]",
    );
    const orbs = mobile.querySelectorAll(
      ".content-switch__orb[data-orb-index]",
    );

    if (!details.length || !orbs.length) {
      return;
    }

    function activateOrb(index) {
      const safeIndex = String(index ?? "0");

      orbs.forEach((orb) => {
        const isActive = orb.dataset.orbIndex === safeIndex;
        orb.classList.toggle("is-active", isActive);
        // Inline state ensures behavior works even if mobile-specific CSS isn't compiled yet.
        orb.style.opacity = isActive ? "1" : "0";
        orb.style.visibility = isActive ? "visible" : "hidden";
        orb.style.zIndex = isActive ? "1" : "0";
      });

      const activeOrb = mobile.querySelector(
        `.content-switch__orb[data-orb-index="${safeIndex}"]`,
      );
      if (activeOrb) {
        activeOrb.classList.add("is-active");
      }

      const ringIndicator = mobile.querySelector(
        ".content-switch__ring-indicator",
      );
      const ringStep = Number.parseInt(safeIndex, 10);
      if (ringIndicator && Number.isFinite(ringStep)) {
        // Desktop rotates by (index + 1) * 72deg for up to 5 satellite positions.
        ringIndicator.style.transform = `rotate(${(ringStep + 1) * 72}deg)`;
      }
    }

    function closeOtherDetails(activeDetail) {
      details.forEach((detail) => {
        if (detail !== activeDetail) {
          detail.open = false;
        }
      });
    }

    let initialOpen = mobile.querySelector(
      ".content-switcher-detail[data-detail-index][open]",
    );

    if (!initialOpen && details[0]) {
      details[0].open = true;
      initialOpen = details[0];
    }

    if (initialOpen) {
      activateOrb(initialOpen.dataset.detailIndex || "0");
      closeOtherDetails(initialOpen);
    }

    details.forEach((detail) => {
      detail.addEventListener("toggle", () => {
        if (detail.open) {
          closeOtherDetails(detail);
          activateOrb(detail.dataset.detailIndex || "0");
        }
      });
    });
  });
});
